import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import imageHoriz from 'public/static/images/warranty-promo-horiz.png';
import imageVert from 'public/static/images/warranty-promo-vert.png';

export const sharedStyles = css`
  .warranty-promo-link {
    width: 100%;
  }

  .warranty-promo {
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid ${colors.G2};
    overflow: hidden;
  }

  .warranty-promo-cta {
    display: block;
    text-align: center;
    width: 116px;
    height: 44px;
    line-height: 40px;
    border-radius: 4px;
    background-color: ${colors.ALR1};
    color: white;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.21px;
  }

  .warranty-promo-cta:hover {
    background-color: ${colors.ALR2};
  }

  .warranty-promo:hover {
    text-decoration: none;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  }

  .warranty-promo:focus {
    text-decoration: none;
  }

  .warranty-promo-image {
    background-repeat: no-repeat;
    background-size: cover;
  }

  .warranty-promo-text {
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
    color: ${colors.BLACK};
  }

  .warranty-promo-subtext {
    display: block;
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.31px;
    color: ${colors.BLACK};
  }
`;

export const horizontalStyles = css`
  .warranty-promo {
    display: flex;
  }

  .warranty-promo-body {
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .warranty-promo-image {
    background-image: url(${imageHoriz});
    position: relative;
    flex: 6;
    min-width: 130px;
    max-width: 307px;
    background-position: right -16px center;
  }

  .warranty-promo-image-mask {
    position: absolute;
    right: -2px;
    height: 100%;
    width: 50px;
  }

  .warranty-promo-text-region {
    margin: auto;
    padding: 8px 1px;
    display: flex;
    flex-direction: column;
  }

  .warranty-promo-subtext {
    width: 200px;
  }

  .warranty-promo-cta {
    margin: 24px 24px 24px auto;
  }
`;

export const verticalStyles = css`
  .warranty-promo-image {
    background-image: url(${imageVert});
    width: 100%;
    height: 92px;
    background-position-x: center;
    background-position-y: center;
    background-size: cover;
  }

  .warranty-promo-image-mask {
    display: none;
  }

  .warranty-promo-body {
    padding: 16px;
  }

  .warranty-promo-subtext {
    margin-top: 4px;
  }

  .warranty-promo-subtext {
    width: 225px;
  }

  .warranty-promo-cta {
    margin-top: 8px;
  }
`;
